import { DownloadButton } from "@src/features/table_filtering/components/download_button";
import { Select } from "antd";
import { DefaultOptionType } from "antd/es/select";
import { useState } from "react";
import "./admin_project_download.less";

interface AdminProjectDownloadProps {
  disabled: boolean;
}

const AdminProjectDownload: React.FC<AdminProjectDownloadProps> = ({
  disabled,
}) => {
  const [selectedId, setSelectedId] = useState<number>(null);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(true);

  function onChange(id: number) {
    setButtonDisabled(id == null);
    setSelectedId(id);
  }

  function getOptions(): DefaultOptionType[] {
    return [
      {
        value: 0,
        label: "Resource Plans",
      },
      {
        value: 1,
        label: "Confirmation History",
      },
    ];
  }

  function getPath(): string {
    switch (selectedId) {
      case 0:
        return "/reports/export-admin-project-overview";
      case 1:
        return "/reports/export-admin-confirmation-history";
      default:
        return "";
    }
  }

  return (
    <div className="admin-project-download">
      <Select
        className="admin-project-download__selection"
        placeholder="please select a download type"
        data-testid="admin-project-download-selection"
        showSearch
        allowClear
        onChange={onChange}
        optionFilterProp="label"
        disabled={disabled}
        options={getOptions()}
      />
      <DownloadButton path={getPath()} disabled={buttonDisabled || disabled} />
    </div>
  );
};

export default AdminProjectDownload;
